import type { IStyleFunctionOrObject } from '@fluentui/react';
import type { IM365Theme } from '@m365-admin/customizations';
import type { INavLinkGroupStyleProps, INavLinkGroupStyles } from '@m365-admin/nav';

export const getNavLinkGroupStyles = (
  props: INavLinkGroupStyleProps,
): IStyleFunctionOrObject<INavLinkGroupStyleProps, INavLinkGroupStyles> => {
  const { isNavCollapsed, theme, isCollapsibleSection } = props;

  return {
    nestedNavHeaderItem: {
      borderRadius: `0px ${theme.effects.roundedCorner4} 0px 0px`,

      '[dir="rtl"] &': {
        borderRadius: `${theme.effects.roundedCorner4} 0px  0px 0px `,
      },
    },
    nestedNavLinksWrapper: [isNavCollapsed && !isCollapsibleSection && {}],
    nestedNavLinks: [
      { backgroundColor: (theme as IM365Theme).semanticColors.navBackground },
      isNavCollapsed &&
        !isCollapsibleSection && {
          borderRadius: `0px 0px ${theme.effects.roundedCorner4} 0px`,
          '[dir="rtl"] &': {
            borderRadius: `0px 0px 0px ${theme.effects.roundedCorner4}`,
          },
          'li:last-child :hover': {
            borderRadius: `0px 0px ${theme.effects.roundedCorner4} 0px`,
          },
          '[dir="rtl"] & li:last-child :hover ': {
            borderRadius: `0px 0px 0px ${theme.effects.roundedCorner4}`,
          },
        },
    ],
  };
};
